{
  "page": {
    "title": "الإعدادات",
    "subtitle": "التغييرات تُطبق على الحجوزات والفواتير الجديدة فقط",
    "save": "حفظ الإعدادات",
    "saved": "تم حفظ الإعدادات"
  },
  "fee": {
    "title": "الرسوم الافتراضية للحجز",
    "percent": "نسبة من قيمة الحجز",
    "fixed": "مبلغ ثابت",
    "percentLabel": "النسبة (%)",
    "amountLabel": "المبلغ ({{currency}})"
  },
  "billing": {
    "title": "أوضاع الفاتورة",
    "hint": "يرى المستخدمون (الملاك والمنسقون) في نموذج الحجز الأوضاع المفعّلة فقط. وضع واحد على الأقل.",
    "default": "الوضع الافتراضي للحجوزات الجديدة"
  },
  "vat": {
    "title": "ضريبة القيمة المضافة",
    "enable": "تفعيل الضريبة",
    "rate": "النسبة (%)",
    "baseFee": "رسوم الخدمة فقط",
    "baseTotal": "إجمالي الفاتورة",
    "enabledInfo": "تُحسب الضريبة على الفواتير الجديدة فقط وتُنسخ النسبة إلى كل فاتورة وقت إصدارها.",
    "disabledInfo": "لا توجد ضريبة حالياً. يظهر بند الضريبة في الفاتورة بنسبة 0%."
  },
  "invoices": {
    "title": "الفواتير",
    "dueDays": "مدة الاستحقاق (أيام)",
    "prefix": "بادئة رقم الفاتورة",
    "prefixHint": "مثال: {{example}}",
    "channels": "قنوات الإرسال",
    "sms": "SMS (دائماً)",
    "email": "البريد عند توفره",
    "whatsapp": "واتساب"
  },
  "alerts": {
    "title": "التنبيهات",
    "contractWarnDays": "التنبيه قبل انتهاء العقد (أيام)"
  },
  "streampay": {
    "title": "ربط StreamPay",
    "testOk": "الاتصال بـ StreamPay ناجح",
    "testFailed": "تعذر الاتصال بـ StreamPay — تحقق من المفاتيح في متغيرات البيئة",
    "reconcileStarted": "بدأت المطابقة في الخلفية",
    "envProduction": "بيئة الإنتاج",
    "envSandbox": "بيئة الاختبار",
    "envMock": "محاكي محلي",
    "disconnected": "غير متصل",
    "connected": "متصل",
    "untested": "لم يُختبر",
    "keysNote": "مفاتيح API محفوظة في متغيرات بيئة الخادم ولا تُعدّل من الواجهة.",
    "webhookUrl": "رابط الإشعارات (Webhook)",
    "copyUrl": "نسخ الرابط",
    "copied": "تم النسخ",
    "lastWebhook": "آخر إشعار مستلم",
    "lastReconcile": "آخر مطابقة",
    "test": "اختبار الاتصال",
    "reconcileNow": "تشغيل المطابقة الآن",
    "lastPoll": "آخر فحص لحالة الدفع (كل {{seconds}} ثانية)",
    "pollSummary": "{{open}} مفتوحة · فُحصت {{checked}} · تغيّرت {{changed}}",
    "pollInterrupted": "توقف مبكراً لتعذر الوصول إلى StreamPay",
    "events": {
      "title": "آخر إشعارات StreamPay",
      "empty": "لم يصل أي إشعار بعد.",
      "event": "الحدث",
      "outcome": "النتيجة",
      "received": "وقت الوصول",
      "pending": "قيد المعالجة",
      "outcomes": {
        "applied": "طُبّق",
        "skipped_already_updated": "تُجوهل (حُدّث مسبقاً)",
        "no_change": "بلا تغيير",
        "ignored_unsupported": "غير مستخدم",
        "unknown_entity": "فاتورة غير معروفة",
        "error": "خطأ"
      }
    }
  },
  "coordinators": {
    "title": "صلاحيات المنسقين",
    "hint": "تنطبق على جميع المنسقين في بوابتهم، وعلى حجوزاتهم فقط.",
    "create": "إضافة وتعديل الحجوزات",
    "confirm": "تأكيد الحجوزات",
    "customers": "تسجيل العملاء",
    "invoices": "إصدار الفواتير"
  }
}
